import {useEffect} from "react";

export default function useChangeDocumentTitle(title?:string){
    useEffect(() => {
        if (title){
            document.title = `${title} | Mark III Systems`
        }
    }, [title])
}